import template from './loansRepaymentModal.html';
import controller from './loansRepaymentModal.controller';
import './loansRepaymentModal.scss';

let loansRepaymentModalComponent = {
  restrict: 'E',
  bindings: {
    success: '<',
    error: '<',
    errorMessage: '<',
    isMobileApp: '<',
    repaymentAmount: '<',
    repaymentType: '<',
    feePeriod: '<'
  },
  template,
  controller
};

export default loansRepaymentModalComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansRepayment/loansRepaymentModal/loansRepaymentModal.component.js